<div center-layout [fullHeight]="true">
  <div stack-layout [maxWidth]="720" width="100%" gap="lg" padding="md">
    <Text
      display="block"
      align="center"
      role="headline-large"
      color="on-background-variant"
      >Welcome to Assurant Trade Bridge</Text
    >
    <!--<app-input placeholder="Search" />-->
    <div
      grid-layout
      gap="md"
      templateColumns="repeat(auto-fit, minmax(160px, 1fr))"
      [fullWidth]="true"
      [fullHeight]="true"
    >
      @for ( item of dashboardItems(); track item) {
      <div
        stack-layout
        border="light"
        borderRadius="xs"
        elevation="raised"
        padding="md"
        alignItems="center"
        gap="sm"
        [fullWidth]="true"
        [fullHeight]="true"
      >
        <Text color="on-primary-surface-variant">
          <Symbol [name]="item.symbol" [opticalSize]="40" />
        </Text>

        <Text role="title-small" align="center">{{ item.title }}</Text>
      </div>
      }
    </div>
  </div>
</div>
